import React from "react";
import { Outlet } from "react-router-dom";
import DomainIcon from "@mui/icons-material/Domain";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { SubNavItem, useSubNav } from "../../context/LayoutContext";
import { usePageHeader } from "../../context/LayoutContext";

const NAV_ITEMS: SubNavItem[] = [
  { label: "Stations", path: "/karda-admin", icon: <DomainIcon fontSize="small" /> },
  { label: "Analytics", path: "/karda-admin/analytics", icon: <BarChartOutlinedIcon fontSize="small" /> },
  { label: "Templates", path: "/karda-admin/templates", icon: <UploadFileIcon fontSize="small" /> },
];

const KardaAdminLayout: React.FC = () => {
  usePageHeader({
    title: "KARDA Admin",
    subtitle: "Manage all organizations' settings and stations",
    icon: <DomainIcon />,
  });
  useSubNav(NAV_ITEMS);

  return <Outlet />;
};

export default KardaAdminLayout;
